<template>
  <hcc-dropdown
    position="top-right"
    :custom="true"
    v-tooltip.down="$t('language.title')"
  >
    <template #button>
      <translate-icon class="icon" />
    </template>
    <hcc-dropdown-item
      @click="changeLanguage('es')"
      :selected="this.$moment.locale() === 'es'"
    >
      <span>{{ $t("language.spanish") }}</span>
    </hcc-dropdown-item>
    <hcc-dropdown-item
      @click="changeLanguage('en')"
      :selected="this.$moment.locale() === 'en'"
    >
      <span>{{ $t("language.english") }}</span>
    </hcc-dropdown-item>
  </hcc-dropdown>
</template>

<script>
import { mapMutations } from 'vuex';
import TranslateIcon from '@/assets/icons/translate.svg';
import { LOCALE_LAGUAGE_CHANGE } from '@/eventTypes';
import EventBus from '@/eventBus';
import HccDropdown from '@/components/shared/HccDropdown/index.vue';
import HccDropdownItem from '@/components/shared/HccDropdown/DropdownItem.vue';
import { setI18nLanguage } from '../i18n';

export default {
  components: {
    TranslateIcon,
    HccDropdown,
    HccDropdownItem,
  },
  methods: {
    ...mapMutations(['setLanguage']),
    changeLanguage(lang) {
      setI18nLanguage(lang);
      this.$moment.locale(lang);
      this.setLanguage(lang);
      EventBus.$emit(LOCALE_LAGUAGE_CHANGE, lang);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/language-button.scss";
</style>
